import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';
import {
	SaveClientSignatureRequestInfo,
	SaveClientSignatureRequestInfoExtras,
} from '../../components/document/SaveAndLoadDocument';
import * as ALL_DOCUMENTS from '../../constants/helloSignDocumentInfo';

// @desc    Get all sales agent's client
import { GetClientDocumentData } from './getClientDocumentData.api';

export async function GetAllSalesAgentsClient(callback) {
	await firebase
		.database()
		.ref('kavtek_clients/' + PROJECT_CODE.projectCode + '/salesAgents')
		.orderByChild('createrID')
		.on('value', async (snapshot) => {
			var nonVisibleClients = [];
			var currentClientList = [];
			var allVisibleClients = [];

			var snapData = snapshot.val();
			console.log('getAllSalesAgentsClient snapData', snapData);

			var allKeys = snapData && Object.keys(snapData);
			console.log('getAllSalesAgentsClient allKeys', allKeys);

			allKeys?.forEach((key) => {
				var thisSalesAgentPointer = key;
				var snapId = snapData[key].createrID;
				var snapClients = snapData[key].myClients;
				var snapEmail = snapData[key].email;
				var snapName = snapData[key].name;

				console.log('getAllSalesAgentsClient myClients', snapClients);

				if (snapClients) {
					var snapClientsKeys =
						snapClients && Object.keys(snapClients);

					console.log(
						'getAllSalesAgentsClient snapClientsKeys',
						snapClientsKeys
					);

					for (var i = 0; i < snapClientsKeys.length; i++) {
						var aClient = snapClients[snapClientsKeys[i]];
						var isForCurrentSalesAgent;
						var coBrokerId = aClient[coBrokerId];

						console.log('DSFSFAS', aClient);
						var apsSignatures;
						var condoDocsSignatures;

						var lastSignatureActivity;

						if (snapEmail === firebase.auth()?.currentUser?.email) {
							isForCurrentSalesAgent = true;
						}
						console.log('getAllSalesAgentsClient aClient', aClient);

						console.log('snapClientsKeys[i]', snapClientsKeys[i]);

						//start getting the status of the document
						//check for document information?
						if (aClient.documentInformation?.signatureRequests) {
							console.log(
								'aClient with documentinformation',
								aClient
							);

							//get the signatureRequests keys;
							var signatureRequests =
								aClient.documentInformation.signatureRequests;

							var signatureRequestsKeys =
								Object.keys(signatureRequests);

							//get the signatureUpdates
							signatureRequestsKeys.forEach(
								(signatureRequestsKey) => {
									var signatureUpdates =
										signatureRequests[signatureRequestsKey];

									var stringSubjectAPS =
										'APS Glenridge Ambria';
									var stringSubjectCondoDocs =
										'Condo Docs Ambria';

									//check if it is APS
									if (
										signatureUpdates['subject'] ===
										stringSubjectAPS
									) {
										//check if there are signature updates
										if (
											signatureUpdates['signatureUpdates']
										) {
											//get the sig updates
											var signatureUpdates =
												signatureUpdates[
													'signatureUpdates'
												];

											console.log(
												'signatureUpdatessignatureUpdates',
												signatureUpdates
											);

											//get the sig updates keys
											var signatureUpdatesKeys =
												Object.keys(signatureUpdates);

											//get the signatures
											apsSignatures =
												signatureUpdates[
													signatureUpdatesKeys[
														signatureUpdatesKeys.length -
															1
													]
												]['signature_request'][
													'signatures'
												];
											aClient['apsSignatures'] =
												apsSignatures;

											//get last signature activity
											lastSignatureActivity =
												signatureUpdates[
													signatureUpdatesKeys[
														signatureUpdatesKeys.length -
															1
													]
												]['event']['event_time'];

											aClient['lastSignatureActivity'] =
												lastSignatureActivity;

											var apsStatus = '';
											//getting the status of the APS
											if (apsSignatures) {
												var apsSignatureArray = [];
												var signatureKeys =
													Object.keys(apsSignatures);

												signatureKeys.forEach(
													(signatureKey) => {
														var status_code =
															apsSignatures[
																signatureKey
															]['status_code'];

														apsSignatureArray.push(
															status_code
														);
													}
												);

												if (
													apsSignatureArray.length ===
													3
												) {
													//3 signatures for one client
													//no second purchaser
													//check the status
													if (
														apsSignatureArray[0] ===
															'awaiting_signature' &&
														apsSignatureArray[1] ===
															'awaiting_signature' &&
														apsSignatureArray[2] ===
															'awaiting_signature'
													) {
														apsStatus =
															'Doc sent to home buyer';
														// } else if (
														// 	apsSignatureArray[0] === 'signed' &&
														// 	apsSignatureArray[1] === 'awaiting_signature' &&
														// 	apsSignatureArray[2] === 'awaiting_signature' )
														// {
														// 	apsStatus = 'Client signed';
													} else if (
														apsSignatureArray[0] ===
															'signed' &&
														apsSignatureArray[1] ===
															'awaiting_signature' &&
														apsSignatureArray[2] ===
															'awaiting_signature'
													) {
														apsStatus =
															'Admin to review';
													} else if (
														apsSignatureArray[0] ===
															'signed' &&
														apsSignatureArray[1] ===
															'signed' &&
														apsSignatureArray[2] ===
															'awaiting_signature'
													) {
														apsStatus =
															'Builder to sign';
													} else if (
														apsSignatureArray[
															apsSignatureArray.length -
																1
														] === 'signed'
													) {
														let currentTime =
															Math.floor(
																Date.now() /
																	1000
															);
														if (
															currentTime -
																parseInt(
																	lastSignatureActivity
																) <
															864000
														) {
															apsStatus =
																'Cooling period';
														} else {
															apsStatus =
																'Firm deal';
														}
													}
												} else if (
													apsSignatureArray.length ===
													4
												) {
													//gelnridge only has 4
													//have second purchaser
													if (
														apsSignatureArray[0] ===
															'awaiting_signature' &&
														apsSignatureArray[1] ===
															'awaiting_signature' &&
														apsSignatureArray[2] ===
															'awaiting_signature' &&
														apsSignatureArray[3] ===
															'awaiting_signature'
													) {
														apsStatus =
															'Doc sent to home buyer';
														// } else if (
														// 	apsSignatureArray[0] === 'signed' &&
														// 	apsSignatureArray[1] === 'awaiting_signature' &&
														// 	apsSignatureArray[2] === 'awaiting_signature' &&
														// 	apsSignatureArray[3] === 'awaiting_signature'
														// ) {
														// 	apsStatus = 'First client signed';
													} else if (
														apsSignatureArray[0] ===
															'signed' &&
														apsSignatureArray[1] ===
															'awaiting_signature' &&
														apsSignatureArray[2] ===
															'awaiting_signature' &&
														apsSignatureArray[3] ===
															'awaiting_signature'
													) {
														apsStatus =
															'Second client to sign';
														// } else if (
														// 	apsSignatureArray[0] === 'signed' &&
														// 	apsSignatureArray[1] === 'signed' &&
														// 	apsSignatureArray[2] === 'signed' &&
														// 	apsSignatureArray[3] === 'awaiting_signature'
														// ) {
														// 	apsStatus = 'Client signed';
													} else if (
														apsSignatureArray[0] ===
															'signed' &&
														apsSignatureArray[1] ===
															'signed' &&
														apsSignatureArray[2] ===
															'awaiting_signature' &&
														apsSignatureArray[3] ===
															'awaiting_signature'
													) {
														apsStatus =
															'Admin to review';
													} else if (
														apsSignatureArray[0] ===
															'signed' &&
														apsSignatureArray[1] ===
															'signed' &&
														apsSignatureArray[2] ===
															'signed' &&
														apsSignatureArray[3] ===
															'awaiting_signature'
													) {
														apsStatus =
															'Builder to sign';
													} else if (
														apsSignatureArray[
															apsSignatureArray.length -
																1
														] === 'signed'
													) {
														let currentTime =
															Math.floor(
																Date.now() /
																	1000
															);
														if (
															currentTime -
																parseInt(
																	lastSignatureActivity
																) <
															864000
														) {
															apsStatus =
																'Cooling period';
														} else {
															apsStatus =
																'Firm deal';
														}
													}
												}
											}
											aClient['apsStatus'] = apsStatus;
											console.log(
												'GET ALL SALES AGENTS APS STATUS ',
												apsStatus
											);
										}
									}

									//check if it is condo docs
									if (
										signatureUpdates['subject'] ===
										stringSubjectCondoDocs
									) {
										//check if there are signature updates
										if (
											signatureUpdates['signatureUpdates']
										) {
											//get the sig updates
											var signatureUpdates =
												signatureUpdates[
													'signatureUpdates'
												];

											//get the sig updates keys
											var signatureUpdatesKeys =
												Object.keys(signatureUpdates);

											//get the signatures
											condoDocsSignatures =
												signatureUpdates[
													signatureUpdatesKeys[
														signatureUpdatesKeys.length -
															1
													]
												]['signature_request'][
													'signatures'
												];
											aClient['condoDocsSignatures'] =
												condoDocsSignatures;

											var condoDocsStatus = '';

											//getting the status of the Condo Docs
											if (condoDocsSignatures) {
												var condoDocsSignaturesArray =
													[];
												var signatureKeys =
													Object.keys(
														condoDocsSignatures
													);

												signatureKeys.forEach(
													(signatureKey) => {
														var status_code =
															condoDocsSignatures[
																signatureKey
															]['status_code'];

														condoDocsSignaturesArray.push(
															status_code
														);
													}
												);

												if (
													condoDocsSignaturesArray.length ===
													1
												) {
													//no second purchaser

													console.log(
														'condoDocsSignaturesArray should be hereee'
													);

													//@TODO: Maybe there is a bug here. THe signatures dont include the admin and builder status right away.
													//check the status
													if (
														condoDocsSignaturesArray[0] ===
														'signed'
													) {
														condoDocsStatus =
															'Condo Document completed';
													} else {
														condoDocsStatus =
															'Waiting for Client to sign';
													}
												} else if (
													condoDocsSignaturesArray.length ==
													2
												) {
													//have second purchaser
													if (
														condoDocsSignaturesArray[0] ===
															'awaiting_signature' &&
														condoDocsSignaturesArray[1] ===
															'awaiting_signature'
													) {
														condoDocsStatus =
															'Waiting for Client to sign';
													} else if (
														condoDocsSignaturesArray[0] ===
															'signed' &&
														condoDocsSignaturesArray[1] ===
															'awaiting_signature'
													) {
														condoDocsStatus =
															'Clients signed. Waiting for Second Client to sign';
													} else if (
														condoDocsSignaturesArray[0] ===
															'signed' &&
														condoDocsSignaturesArray[1] ===
															'signed'
													) {
														condoDocsStatus =
															'Condo Document completed';
													}
												} else if (
													condoDocsSignaturesArray[
														condoDocsSignaturesArray.length -
															1
													] === 'signed'
												) {
													condoDocsStatus =
														'Condo Document completed';
												}
											}

											aClient['condoDocsStatus'] =
												condoDocsStatus;
										}
									}
								}
							);
						}

						aClient['keyValue'] = snapClientsKeys[i];
						aClient['salesAgentId'] = snapId;
						aClient['salesAgentEmail'] = snapEmail;
						aClient['salesAgentName'] = snapName;
						aClient['salesAgentPointer'] = thisSalesAgentPointer;
						aClient['isForCurrentSalesAgent'] =
							isForCurrentSalesAgent;

						console.log('');
						console.log('aClientaClient', aClient);

						listDocuments(aClient, (returned) => {
							aClient.documentHistory = returned;
						});

						currentClientList.push(aClient);
					}
				}
			});

			console.log('currentClientList super admin', currentClientList);

			await pushToClient(
				currentClientList,
				(returned) => allVisibleClients.push(returned),
				(returned) => nonVisibleClients.push(returned)
			);

			callback(allVisibleClients);
		});
}

export async function listDocuments(client, callback) {
	var documentHistory;
	var documentInformation = client?.documentInformation;
	var documentSignatureRequests = documentInformation?.signatureRequests;
	var apsSignatures = client.apsSignatures;
	var condoDocsSignatures = client.condoDocsSignatures;

	var apsDocumentObj =
		documentSignatureRequests &&
		documentSignatureRequests[Object?.keys(documentSignatureRequests)[0]];

	var condoDocsDocumentObj =
		documentSignatureRequests &&
		documentSignatureRequests[Object?.keys(documentSignatureRequests)[1]];

	var apsTimestamp = apsDocumentObj?.timestamp;
	var condoDocsTimestamp = condoDocsDocumentObj?.created_at;

	function apsStatus() {
		var status;

		//case APS is created but not sent
		if (
			documentInformation &&
			documentInformation.documentStatus !== 'sent'
		) {
			status = 'started_not_sent';
		} else if (apsSignatures !== undefined) {
			var apsSignaturesObjKeys = Object.keys(apsSignatures);

			var signatureStatus = [];

			apsSignaturesObjKeys.forEach((key) => {
				signatureStatus.push(apsSignatures[key].status_code);
			});

			//one purchaser
			if (signatureStatus.length === 3) {
				if (
					signatureStatus[0] === 'awaiting_signature' &&
					signatureStatus[1] === 'awaiting_signature' &&
					signatureStatus[2] === 'awaiting_signature'
				) {
					status = 'doc_sent';
				} else if (
					signatureStatus[0] === 'signed' &&
					signatureStatus[1] === 'awaiting_signature' &&
					signatureStatus[2] === 'awaiting_signature'
				) {
					status = 'client_signed';
				} else if (
					signatureStatus[0] === 'signed' &&
					signatureStatus[1] === 'signed' &&
					signatureStatus[2] === 'awaiting_signature'
				) {
					status = 'admin_signed';
				} else if (
					signatureStatus[0] === 'signed' &&
					signatureStatus[1] === 'signed' &&
					signatureStatus[2] === 'signed'
				) {
					status = 'builder_signed';
				}
			} else {
				//second purchaser
				if (
					signatureStatus[0] === 'awaiting_signature' &&
					signatureStatus[1] === 'awaiting_signature' &&
					signatureStatus[2] === 'awaiting_signature' &&
					signatureStatus[3] === 'awaiting_signature'
				) {
					status = 'doc_sent';
				} else if (
					signatureStatus[0] === 'signed' &&
					signatureStatus[1] === 'awaiting_signature' &&
					signatureStatus[2] === 'awaiting_signature' &&
					signatureStatus[3] === 'awaiting_signature'
				) {
					status = 'doc_sent';
				} else if (
					signatureStatus[0] === 'signed' &&
					signatureStatus[1] === 'signed' &&
					signatureStatus[2] === 'awaiting_signature' &&
					signatureStatus[3] === 'awaiting_signature'
				) {
					status = 'client_signed';
				} else if (
					signatureStatus[0] === 'signed' &&
					signatureStatus[1] === 'signed' &&
					signatureStatus[2] === 'signed' &&
					signatureStatus[3] === 'awaiting_signature'
				) {
					status = 'admin_signed';
				} else if (
					signatureStatus[0] === 'signed' &&
					signatureStatus[1] === 'signed' &&
					signatureStatus[2] === 'signed' &&
					signatureStatus[3] === 'signed'
				) {
					status = 'builder_signed';
				}
			}
		} else {
			status = 'not_started';
		}

		console.log('statuss', status);

		return status;
	}

	function condoDocsStatus() {
		var status;

		//case APS is created but not sent
		if (condoDocsSignatures !== undefined) {
			var condoDocsSignaturesObjKeys = Object.keys(condoDocsSignatures);

			var signatureStatus = [];

			condoDocsSignaturesObjKeys.forEach((key) => {
				signatureStatus.push(condoDocsSignatures[key].status_code);
			});

			console.log('signatureStatus', signatureStatus);

			//one purchaser
			if (signatureStatus.length === 1) {
				if (signatureStatus[0] === 'awaiting_signature') {
					status = 'doc_sent';
				} else if (signatureStatus[0] === 'signed') {
					status = 'builder_signed';
				}
			} else {
				//second purchaser
				if (
					signatureStatus[0] === 'awaiting_signature' &&
					signatureStatus[1] === 'awaiting_signature'
				) {
					status = 'doc_sent';
				} else if (
					signatureStatus[0] === 'signed' &&
					signatureStatus[1] === 'awaiting_signature'
				) {
					status = 'doc_sent';
				} else if (
					signatureStatus[0] === 'signed' &&
					signatureStatus[1] === 'signed'
				) {
					status = 'client_signed';
				}
			}
		} else {
			status = 'not_started';
		}

		console.log('statuss', status);

		return status;
	}

	var aps = {
		documentName: 'APS',
		documentStatus: apsStatus(),
		timestamp: apsTimestamp,
	};

	var condoDocs = {
		documentName: 'Condo Docs',
		documentStatus: condoDocsStatus(),
		timestamp: condoDocsTimestamp,
	};

	documentHistory = [aps, condoDocs];

	callback(documentHistory);
}

export async function pushToClient(
	currentClientList,
	allVisibleClients,
	nonVisibleClients
) {
	for (const client of currentClientList) {
		console.log('currentClientList', currentClientList);
		if (client.showClient === true) {
			await GetClientExpandedInfo(client).then((result) => {
				client['expandedClientInfo'] = result;
			});

			allVisibleClients(client);
		} else {
			nonVisibleClients(client);
		}
	}
}

export async function GetAllVisibleClientsForSpecificClient() {
	//const { firebase } = useContext(FirebaseContext);

	var allVisibleClients = [];
	var nonVisibleClients = [];

	var currentUserId = firebase.auth().currentUser?.uid;
	var currentClientList = [];

	var thisSalesAgentPointer;

	await firebase
		.database()
		.ref('kavtek_clients/' + PROJECT_CODE.projectCode + '/salesAgents')
		.orderByChild('createrID')
		.equalTo(currentUserId)
		.limitToFirst(1)
		.once('value', (snapshot) => {
			var snapData = snapshot.val();

			//console.log("SnapData " +  JSON.stringify(snapData));

			var allKeys = Object.keys(snapData);

			//var keyToCall = snapData[allKeys[0]];

			thisSalesAgentPointer = allKeys[0];

			return thisSalesAgentPointer;
		});

	console.log('saveOrUpdateDocument key' + thisSalesAgentPointer);
	await firebase
		.database()
		.ref(
			'kavtek_clients/' +
				PROJECT_CODE.projectCode +
				'/salesAgents/' +
				thisSalesAgentPointer +
				'/myClients'
		)
		.once('value', (snapshot) => {
			//console.log(JSON.stringify(snapshot.val()));
			snapshot.forEach((clientData) => {
				var aClient = clientData.val();

				aClient['keyValue'] = clientData.key;
				aClient['salesAgentPointer'] = thisSalesAgentPointer;

				//console.log(" Client email " + aClient.clientEmail + " id " + aClient.id + " client key " + clientData.key);
				currentClientList.push(aClient);
			});
		});

	//for(const client of currentClientList)

	//currentClientList.forEach(async (client) => {

	for (const client of currentClientList) {
		console.log('currentClientList', currentClientList);
		if (client.showClient === true) {
			await GetClientExpandedInfo(client).then((result) => {
				client['expandedClientInfo'] = result;

				//console.log("Current Client List Add to client " + JSON.stringify(result));
			});

			console.log('Adding client to list');

			allVisibleClients.push(client);
		} else {
			nonVisibleClients.push(client);
		}
	}

	console.log('Visible Client RECEIVED', allVisibleClients);

	return allVisibleClients;
}

export async function GetSpecificClient(_clientEmail) {
	var allClients;
	await GetAllVisibleClientsForSpecificClient().then((returned) => {
		allClients = returned;
	});

	var thisClient;

	allClients.forEach((client) => {
		if (client.clientEmail === _clientEmail) {
			thisClient = client;
		}
	});

	return thisClient;
}

export async function GetClientExpandedInfo(client) {
	// data-appcode={client.appCode}
	// data-keyvalue={client.keyValue}
	// data-salesagentpointer={client.salesAgentPointer}
	// data-name={client.fullName}
	// data-docsent={client?.documentInformation?.documentStatus}
	// data-clientemail={client.clientEmail}

	var dataSet = {
		appcode: client.appCode,
		keyvalue: client.keyValue,
		salesagentpointer: client.salesAgentPointer,
		name: client.fullName,
		docsent: client?.documentInformation?.documentStatus,
		clientemail: client.clientEmail,
	};

	var currentUserId = client.salesAgentId;

	console.log('GetClientExpandedInfo curentuserId', currentUserId);

	var clientExpanded;

	await GetClientDocumentData(dataSet, currentUserId).then((result) => {
		console.log('this is the result for GetClientDocumentData', result);
		clientExpanded = result;

		console.log(
			JSON.stringify(dataSet),
			' Super ReturnInfExpandedClients ',
			JSON.stringify(result)
		);
	});

	return clientExpanded;
}
